// Podtemat 4 - zadania otwarte egzaminu osmoklasisty z dzialu VI (planimetria).

import * as TrapezoidAngles from "../../temat2_czworokaty/podtemat3_trapezy_types/E8TrapezoidAnglesOpenTask";
import * as SquareGridQuadrilateralArea from "../../temat2_czworokaty/podtemat1_prostokaty_kwadraty_types/E8SquareGridQuadrilateralAreaOpenTask";
import * as ScaleAreaRatio from "../E8ScaleAreaRatioOpenTask";
import * as TrapezoidGardenSeeds from "../E8TrapezoidGardenSeedsOpenTask";
import * as RectangleCutParallelogramPerimeter from "../E8RectangleCutParallelogramPerimeterOpenTask";

export const registry = {
  E8TrapezoidAnglesOpenTask: TrapezoidAngles,
  E8ScaleAreaRatioOpenTask: ScaleAreaRatio,
  E8SquareGridQuadrilateralAreaOpenTask: SquareGridQuadrilateralArea,
  E8TrapezoidGardenSeedsOpenTask: TrapezoidGardenSeeds,
  E8RectangleCutParallelogramPerimeterOpenTask: RectangleCutParallelogramPerimeter,
};

export function generateTasks(options = {}) {
  if (options.variant === "original" && options.session === "2026_MAJ") {
    return [
      TrapezoidGardenSeeds.generateTask(options),
      RectangleCutParallelogramPerimeter.generateTask(options),
    ];
  }

  return [
    TrapezoidAngles.generateTask(options),
    ScaleAreaRatio.generateTask(options),
    SquareGridQuadrilateralArea.generateTask(options),
    TrapezoidGardenSeeds.generateTask(options),
    RectangleCutParallelogramPerimeter.generateTask(options),
  ];
}

function moduleFor(task) {
  const mod = registry[task.type];
  if (!mod) throw new Error(`Unknown E8 open task type in planimetria: ${task.type}`);
  return mod;
}

export function renderTask(task) {
  return moduleFor(task).renderTask(task);
}

export function renderInput(task, userAnswer, onChange, disabled) {
  return moduleFor(task).renderInput(task, userAnswer, onChange, disabled);
}

export function checkAnswer(task, userAnswer) {
  return moduleFor(task).checkAnswer(task, userAnswer);
}

export function renderAnswer(task) {
  return moduleFor(task).renderAnswer(task);
}

export function renderExplanation(task) {
  return moduleFor(task).renderExplanation(task);
}

export function renderUserAnswer(userAnswer, task) {
  return moduleFor(task).renderUserAnswer(userAnswer, task);
}